module.exports = __webpack_public_path__ + "static/media/redieselpecas.ea39c343.webp";